import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';



class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}

class School {
    key:number;
    school:string;
    icon:string;
}
let Schools: School[] = [
    {   
        key:1,
        school:"Appalachian State University",
        icon:Tgcc.ResolveUrl('~/images/AppState.png'),
    },
    {   
        key:2,
        school:"Auburn University",
        icon:Tgcc.ResolveUrl('~/images/Auburn.png'),
    },
    {   
        key:3,
        school:"Augusta University",
        icon:Tgcc.ResolveUrl('~/images/AugustaUniversity.png'),
    },
    {   
        key:4,
        school:"Austin Peay State University",
        icon:Tgcc.ResolveUrl('~/images/AustinPeayState.png'),
    },
    {   
        key:5,
        school:"Baylor University",
        icon:Tgcc.ResolveUrl('~/images/Baylor.png'),
    },
    {   
        key:6,
        school:"Belmont University",
        icon:Tgcc.ResolveUrl('~/images/BelmontUniversity.png'),
    },
    {   
        key:7,
        school:"Campbell University",
        icon:Tgcc.ResolveUrl('~/images/Campbell.png'),
    },
    {   
        key:8,
        school:"Central Michigan University",
        icon:Tgcc.ResolveUrl('~/images/CentralMichigan.png'),
    },
    {   
        key:9,
        school:"Charleston Southern University",
        icon:Tgcc.ResolveUrl('~/images/CharlestonSouthern.png'),
    },
    {   
        key:10,
        school:"Christopher Newport University",
        icon:Tgcc.ResolveUrl('~/images/ChristopherNewport.png'),
    },
    {   
        key:11,
        school:"Clemson University",
        icon:Tgcc.ResolveUrl('~/images/Clemson.png'),
    },
    {   
        key:12,
        school:"Coastal Carolina University",
        icon:Tgcc.ResolveUrl('~/images/CostalCarolina.png'),
    },
    {   
        key:13,
        school:"College of Charleston",
        icon:Tgcc.ResolveUrl('~/images/Charleston.png'),
    },
    {   
        key:14,
        school:"Colorado State University",
        icon:Tgcc.ResolveUrl('~/images/ColoradoStateUniversity.png'),
    },
    {   
        key:15,
        school:"Davidson College",
        icon:Tgcc.ResolveUrl('~/images/Davidson.png'),
    },
    {   
        key:16,
        school:"Delta State University",
        icon:Tgcc.ResolveUrl('~/images/DeltaState.png'),
    },
    {   
        key:17,
        school:"East Carolina University",
        icon:Tgcc.ResolveUrl('~/images/EastCarolina.png'),
    },
    {   
        key:18,
        school:"East Tennessee State University",
        icon:Tgcc.ResolveUrl('~/images/EastTennesseeStateUniversity.png'),
    },
    {   
        key:19,
        school:"Eastern Kentucky University",
        icon:Tgcc.ResolveUrl('~/images/EasternKentuky1.png'),
    },
    {   
        key:20,
        school:"Elon University",
        icon:Tgcc.ResolveUrl('~/images/Elon.png'),
    },
    {   
        key:21,
        school:"Emory University",
        icon:Tgcc.ResolveUrl('~/images/Emory.png'),
    },
    {   
        key:22,
        school:"Florida Atlantic University",
        icon:Tgcc.ResolveUrl('~/images/FloridaAtlanticUniversity.png'),
    },
    {   
        key:23,
        school:"Florida Gulf Coast University",
        icon:Tgcc.ResolveUrl('~/images/FloridaGulfCoast.png'),
    },
    {   
        key:24,
        school:"Florida State University",
        icon:Tgcc.ResolveUrl('~/images/FloridaState.png'),
    },
    {   
        key:25,
        school:"Francis Marion University",
        icon:Tgcc.ResolveUrl('~/images/FrancisMarionUniversity.png'),
    },
    {   
        key:26,
        school:"Furman University",
        icon:Tgcc.ResolveUrl('~/images/Furman.png'),
    },
    {   
        key:27,
        school:"Georgia College",
        icon:Tgcc.ResolveUrl('~/images/GeorgiaCollege.png'),
    },
    {   
        key:28,
        school:"Georgia Institute of Technology",
        icon:Tgcc.ResolveUrl('~/images/GeorgiaTech.png'),
    },
    {   
        key:29,
        school:"Georgia Southern University",
        icon:Tgcc.ResolveUrl('~/images/GeorgiaSouthern.png'),
    },
    {   
        key:30,
        school:"Georgia State University",
        icon:Tgcc.ResolveUrl('~/images/GeorgiaState.png'),
    },
    {   
        key:31,
        school:"Hampden-Sydney College",
        icon:Tgcc.ResolveUrl('~/images/Hampden-Sydney.png'),
    },
    {   
        key:32,
        school:"High Point University",
        icon:Tgcc.ResolveUrl('~/images/HighPointUniversity.png'),
    },
    {   
        key:33,
        school:"Houston Baptist University",
        icon:Tgcc.ResolveUrl('~/images/HoustonBaptistUniversity.png'),
    },
    {   
        key:34,
        school:"Ithaca College",
        icon:Tgcc.ResolveUrl('~/images/IthacaCollege1.png'),
    },
    {   
        key:35,
        school:"Jacksonville University",
        icon:Tgcc.ResolveUrl('~/images/JacksonvilleUniversity.png'),
    },
    {   
        key:36,
        school:"Jacksonville State University",
        icon:Tgcc.ResolveUrl('~/images/JacksonvilleState.png'),
    },
    {   
        key:37,
        school:"Kent State University",
        icon:Tgcc.ResolveUrl('~/images/KentStateUniversity.png'),
    },
    {   
        key:38,
        school:"Lenoir-Rhyne University",
        icon:Tgcc.ResolveUrl('~/images/Lenoir-RhyneUniversity.png'),
    },
    {   
        key:39,
        school:"Longwood University",
        icon:Tgcc.ResolveUrl('~/images/Longwood.png'),
    },
    {   
        key:40,
        school:"Louisiana Tech University",
        icon:Tgcc.ResolveUrl('~/images/LouisianaTechUniversity.png'),
    },
    {   
        key:41,
        school:"Louisiana State University",
        icon:Tgcc.ResolveUrl('~/images/LSU1.png'),
    },
    {   
        key:42,
        school:"LSU Health Science Center Shreveport",
        icon:Tgcc.ResolveUrl('~/images/LSUHealthScienceCenterShreveport.png'),
    },
    {   
        key:43,
        school:"Mercer University",
        icon:Tgcc.ResolveUrl('~/images/Mercer.png'),
    },
    {   
        key:44,
        school:"Middle Tennessee State University",
        icon:Tgcc.ResolveUrl('~/images/MiddleTennessee.png'),
    },
    {   
        key:45,
        school:"Mississippi State University",
        icon:Tgcc.ResolveUrl('~/images/MississippiState.png'),
    },
    {   
        key:46,
        school:"Mississippi University for Women",
        icon:Tgcc.ResolveUrl('~/images/MississippiUniversityforWomen.png'),
    },
    {   
        key:47,
        school:"Morehead State University",
        icon:Tgcc.ResolveUrl('~/images/MoreheadStateUniversity.png'),
    },
    {   
        key:48,
        school:"Murray State University",
        icon:Tgcc.ResolveUrl('~/images/MurrayState.png'),
    },
    {   
        key:49,
        school:"Newberry College",
        icon:Tgcc.ResolveUrl('~/images/NewberryCollege.png'),
    },
    {   
        key:50,
        school:"Nicholls State University",
        icon:Tgcc.ResolveUrl('~/images/NichollsState.png'),
    },
    {   
        key:51,
        school:"Northeastern University",
        icon:Tgcc.ResolveUrl('~/images/NortheasternUniversity.png'),
    },
    {   
        key:52,
        school:"Northwestern State University",
        icon:Tgcc.ResolveUrl('~/images/NorthwesternState.png'),
    },
    {   
        key:53,
        school:"North Carolina State University",
        icon:Tgcc.ResolveUrl('~/images/NorthCarolinaState.png'),
    },
    {   
        key:54,
        school:"Nova Southeastern University",
        icon:Tgcc.ResolveUrl('~/images/NovaSoutheasternUniversity.png'),
    },
    {   
        key:55,
        school:"Ohio University",
        icon:Tgcc.ResolveUrl('~/images/OhioUniversity.png'),
    },
    {   
        key:56,
        school:"Old Dominion University",
        icon:Tgcc.ResolveUrl('~/images/OldDominion.png'),
    },
    {   
        key:57,
        school:"Pittsburg State University",
        icon:Tgcc.ResolveUrl('~/images/PittsburgStateUniversity.png'),
    },
    {   
        key:58,
        school:"Presbyterian College",
        icon:Tgcc.ResolveUrl('~/images/PresbyterianCollege.png'),
    },
    {   
        key:59,
        school:"Radford University",
        icon:Tgcc.ResolveUrl('~/images/Radford.png'),
    },
    {   
        key:60,
        school:"Samford University",
        icon:Tgcc.ResolveUrl('~/images/Samford.png'),
    },
    {   
        key:61,
        school:"Southeastern Louisiana University",
        icon:Tgcc.ResolveUrl('~/images/SoutheasternLouisianaUniversity.png'),
    },
    {   
        key:62,
        school:"Southeastern Missouri State University",
        icon:Tgcc.ResolveUrl('~/images/SoutheastMissouriState.png'),
    },
    {   
        key:63,
        school:"Southern Methodist University",
        icon:Tgcc.ResolveUrl('~/images/SouthernMethodistUniversity.png'),
    },
    {   
        key:64,
        school:"Stetson University",
        icon:Tgcc.ResolveUrl('~/images/StetsonUniversity.png'),
    },
    {   
        key:65,
        school:"Stephen F Austin State University",
        icon:Tgcc.ResolveUrl('~/images/StephenFAustinState.png'),
    },
    {   
        key:66,
        school:"Tennessee Tech University",
        icon:Tgcc.ResolveUrl('~/images/TennesseeTech.png'),
    },
    {   
        key:67,
        school:"Texas A&M University",
        icon:Tgcc.ResolveUrl('~/images/TexasA&M.png'),
    },
    {   
        key:68,
        school:"Texas Christian University",
        icon:Tgcc.ResolveUrl('~/images/TCU.png'),
    },
    {   
        key:69,
        school:"Texas State University",
        icon:Tgcc.ResolveUrl('~/images/TexasStateUniversity.png'),
    },
    {   
        key:70,
        school:"The Citadel",
        icon:Tgcc.ResolveUrl('~/images/Citadel1.png'),
    },
    {   
        key:71,
        school:"Towson University",
        icon:Tgcc.ResolveUrl('~/images/TowsonUniversity.png'),
    },
    {   
        key:72,
        school:"Troy University",
        icon:Tgcc.ResolveUrl('~/images/TroyUniversity.png'),
    },
    {   
        key:73,
        school:"Tulane University",
        icon:Tgcc.ResolveUrl('~/images/Tulane.png'),
    },
    {   
        key:74,
        school:"United States Military Academy(Army)",
        icon:Tgcc.ResolveUrl('~/images/UnitedStatesMilitaryAcademy(Army).png'),
    },
    {   
        key:75,
        school:"United States Naval Academy(Navy)",
        icon:Tgcc.ResolveUrl('~/images/UnitedStatesNavalAcademy(Navy).png'),
    },
    {   
        key:76,
        school:"University of Alabama - Huntsville",
        icon:Tgcc.ResolveUrl('~/images/UniversityofAlabama-Huntsville.png'),
    },
    {   
        key:77,
        school:"University of Alabama",
        icon:Tgcc.ResolveUrl('~/images/Alabama.png'),
    },
    {   
        key:78,
        school:"University of Alabama at Birmingham",
        icon:Tgcc.ResolveUrl('~/images/AlabamaBirmingham.png'),
    },
    {   
        key:79,
        school:"University of Arkansas",
        icon:Tgcc.ResolveUrl('~/images/Arkansas1.png'),
    },
    {   
        key:80,
        school:"University of Arkansas - Little Rock",
        icon:Tgcc.ResolveUrl('~/images/UniversityofArkansasatLittleRock1.png'),
    },
    {   
        key:81,
        school:"University of Arkansas - Monticello",
        icon:Tgcc.ResolveUrl('~/images/UniversityofArkansasMonticello.png'),
    },
    {   
        key:82,
        school:"University of Central Arkansas",
        icon:Tgcc.ResolveUrl('~/images/UniversityofCentralArkansas.png'),
    },
    {   
        key:83,
        school:"University of Dayton",
        icon:Tgcc.ResolveUrl('~/images/Dayton.png'),
    },
    {   
        key:84,
        school:"University of Evansville",
        icon:Tgcc.ResolveUrl('~/images/UniversityofEvansville.png'),
    },
    {   
        key:85,
        school:"University of Florida",
        icon:Tgcc.ResolveUrl('~/images/Florida1.png'),
    },
    {   
        key:86,
        school:"University of Georgia",
        icon:Tgcc.ResolveUrl('~/images/UniveristyofGeorgia.png'),
    },
    {   
        key:87,
        school:"University of Houston",
        icon:Tgcc.ResolveUrl('~/images/Houston.png'),
    },
    {   
        key:88,
        school:"University of Kentucky",
        icon:Tgcc.ResolveUrl('~/images/UniversityofKentucky.png'),
    },
    {   
        key:89,
        school:"University of Louisiana at Lafayette",
        icon:Tgcc.ResolveUrl('~/images/LouisianaLafayette.png'),
    },
    {   
        key:90,
        school:"University of Louisiana at Monroe",
        icon:Tgcc.ResolveUrl('~/images/LouisianaMonroe.png'),
    },
    {   
        key:91,
        school:"University of Memphis",
        icon:Tgcc.ResolveUrl('~/images/Memphis.png'),
    },
    {   
        key:92,
        school:"University of Miami",
        icon:Tgcc.ResolveUrl('~/images/UniversityofMiami.png'),
    },
    {   
        key:93,
        school:"University of Mississippi",
        icon:Tgcc.ResolveUrl('~/images/UniversityofMississippi.png'),
    },
   
    {   
        key:94,
        school:"University of North Carolina - Asheville",
        icon:Tgcc.ResolveUrl('~/images/UniversityofNorthCarolina-Asheville.png'),
    },
    {   
        key:95,
        school:"University of North Carolina - Chapel Hill",
        icon:Tgcc.ResolveUrl('~/images/UNC.png'),
    },
    {   
        key:96,
        school:"University of North Carolina at Charlotte",
        icon:Tgcc.ResolveUrl('~/images/UniversityofNorthCarolinaatCharlotte.png'),
    },
    {   
        key:97,
        school:"University of North Carolina - Wilmington",
        icon:Tgcc.ResolveUrl('~/images/UniversityofNorthCarolina-Wilmington.png'),
    },
    {   
        key:98,
        school:"University of North Florida",
        icon:Tgcc.ResolveUrl('~/images/NorthFlorida.png'),
    },
    {   
        key:99,
        school:"University of North Georgia",
        icon:Tgcc.ResolveUrl('~/images/NorthGeorgia.png'),
    },
    {   
        key:100,
        school:"University of Richmond",
        icon:Tgcc.ResolveUrl('~/images/Richmond1.png'),
    },
    {   
        key:101,
        school:"University of South Alabama",
        icon:Tgcc.ResolveUrl('~/images/UniversityofSouthAlabama1.png'),
    },
    {   
        key:102,
        school:"University of South Carolina",
        icon:Tgcc.ResolveUrl('~/images/USC.png'),
    },
    {   
        key:103,
        school:"University of Southern Mississippi",
        icon:Tgcc.ResolveUrl('~/images/SouthernMississippi.png'),
    },
    {   
        key:104,
        school:"University of Tennessee",
        icon:Tgcc.ResolveUrl('~/images/Tennessee.png'),
    },
    {   
        key:105,
        school:"University of Tennessee at Chattanooga",
        icon:Tgcc.ResolveUrl('~/images/TennesseeChattanooga.png'),
    },
    {   
        key:106,
        school:"University of Tennessee at Martin",
        icon:Tgcc.ResolveUrl('~/images/TennesseeMartin.png'),
    },
    {   
        key:107,
        school:"University of Tennessee Health Science Center",
        icon:Tgcc.ResolveUrl('~/images/TennesseeHealthScience.png'),
    },
    {   
        key:108,
        school:"University of Texas - San Antonio",
        icon:Tgcc.ResolveUrl('~/images/UniversityofTexas-SanAntonio.png'),
    },
    {   
        key:109,
        school:"University of Tulsa",
        icon:Tgcc.ResolveUrl('~/images/Tulsa1.png'),
    },
    {   
        key:110,
        school:"University of Virginia",
        icon:Tgcc.ResolveUrl('~/images/UVA.png'),
    },
    {   
        key:111,
        school:"University of West Florida",
        icon:Tgcc.ResolveUrl('~/images/UniversityofWestFlorida.png'),
    },
    {   
        key:112,
        school:"University of West Georgia",
        icon:Tgcc.ResolveUrl('~/images/UniversityofWestGeorgia.png'),
    },
    {   
        key:113,
        school:"Valdosta State University",
        icon:Tgcc.ResolveUrl('~/images/ValdostaStateUniversity.png'),
    },
    {   
        key:114,
        school:"Vanderbilt University",
        icon:Tgcc.ResolveUrl('~/images/Vanderbilt.png'),
    },
    {   
        key:115,
        school:"Virginia Military Institute",
        icon:Tgcc.ResolveUrl('~/images/VirginiaMilitaryInstitute.png'),
    },
    {   
        key:116,
        school:"Virginia Tech",
        icon:Tgcc.ResolveUrl('~/images/VirginiaTech.png'),
    },
    {   
        key:117,
        school:"Wake Forest University",
        icon:Tgcc.ResolveUrl('~/images/WakeForest.png'),
    },
    {   
        key:118,
        school:"Washington and Lee University",
        icon:Tgcc.ResolveUrl('~/images/WashingtonandLeeUniversity.png'),
    },
    {   
        key:119,
        school:"Western Carolina University",
        icon:Tgcc.ResolveUrl('~/images/WesternCarolina.png'),
    },
    {   
        key:120,
        school:"Western Kentucky University",
        icon:Tgcc.ResolveUrl('~/images/WesternKentuky.png'),
    },
    {   
        key:121,
        school:"Wingate University",
        icon:Tgcc.ResolveUrl('~/images/WingateUniversity.png'),
    },
    {   
        key:122,
        school:"Winthrop University",
        icon:Tgcc.ResolveUrl('~/images/Winthrop.png'),
    },
    {   
        key:123,
        school:"Wofford University",
        icon:Tgcc.ResolveUrl('~/images/Wofford.png'),
    },
]

const schoolStyle: React.CSSProperties = {
    width:'35px',
    height:'35px',
    display:'inline-block'
}

const schoolName: React.CSSProperties = {
    fontFamily:'AveriaSerifRegular',
    color:'#A6A6A6',
    fontSize:'12px',
    display:'inline-block',
    position:'relative',
    top:'-10px',
    left:'10px',
    marginRight:'15px'
}
const container: React.CSSProperties = {
    margin:'50px auto auto auto',
    width:'1000px',    
    display: 'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    justifyContent:'space-around',
    height:'1300px',
}
const hdr: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'Reitam',
    color:'#A6A6A6',
    textDecoration:'underline'
}
const style: React.CSSProperties = {
    flex:1,
}

const pageCont: React.CSSProperties = {
    backgroundColor:"#F7F5F0"
}



class _OtherSchools extends React.Component <Props, any > {
    state = {
        homepage:""
    }

    getHrzLines() {
        return (
            <div>
                <div></div>
                <div></div>
            </div>
        )
    }
    getLength(){
        console.log(Schools.length);
    }

    
  
    render() {
        return (
                <div style={pageCont}>
                    <CampusHeader />
                    <div style={hdr}>Licensed with 120&#43; Colleges &#38; Universities</div>
                    {this.getLength()}
                    <div style={container} className='otherSchools'>
                    {Schools.map((school:School) => {return <div key={school.key} style={style}><img src={school.icon} style={schoolStyle}/><div style={schoolName}>{school.school}</div></div>})}
                    </div>
                        <CampusFooter state={this.props.state} />

                </div>
        );
    }
}


var radiumSchools = Radium(_OtherSchools);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { ActiveProof: state.ActiveProof,
             state:state}
};
export var OtherSchools = connect(mapStateToProps)(radiumSchools);



